export default __webpack_public_path__ + "static/media/iata-dt.4763e577.png";